import { wplToken } from '@atlassiansox/wpl-token';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const searchFormContainerStyle = css`
  ${getMediaDown('md')} {
    display: block;
    position: fixed;
    width: 100%;
    z-index: 1000;
    padding: ${wplToken('space.100')} ${wplToken('space.0')};
    inset: 0px;
    box-shadow: 0px 3px 5px 0px #091e4233;
    > div:first-of-type {
      display: none;
    }
  }
  display: flex;
  position: absolute;
  right: 0;
  top: 130%;
  z-index: 10;
  width: 22.5rem;
  padding: ${wplToken('space.200')} ${wplToken('space.0')};
  flex-direction: column;
  align-items: flex-start;

  border-radius: ${wplToken('space.025')};
  background: ${getColor('n0')};

  /* shadow-dropdown */
  box-shadow: 0px 0px 1px 0px rgba(9, 30, 66, 0.31),
    0px 3px 5px 0px rgba(9, 30, 66, 0.2);
`;

export const searchFormTitleStyle = css`
  display: flex;
  padding: ${wplToken('space.0')} ${wplToken('space.200')}
    ${wplToken('space.200')} ${wplToken('space.200')};
  font-size: 1.125rem;
  font-weight: 500;
  align-items: flex-start;
  gap: 0.625rem;
  align-self: stretch;
  font-family: var(--bxp-charlie-text-font-family);
`;

export const searchInputStyle = css`
  display: flex;
  padding: ${wplToken('space.0')} ${wplToken('space.200')};
  align-items: flex-start;
  gap: ${wplToken('space.200')};
  align-self: stretch;
  > div {
    width: 100%;
  }
  ${getMediaDown('md')} {
    padding: ${wplToken('space.100')} ${wplToken('space.0')};
    padding-top: ${wplToken('space.0')};
    box-shadow: 0px 1px 0px 0px rgba(9, 30, 66, 0.2);
    gap: ${wplToken('space.100')};
    > div:first-of-type {
      width: 40px;
    }
    > div:nth-of-type(2) {
      width: 80%;
    }
  }
`;

export const spinnerStyles = css`
  position: relative;
  top: -5px;
`;

export const searchResultContainerStyle = css`
  ${getMediaDown('md')} {
    max-height: calc(100% - 3.125rem);
  }
  font-size: 1rem;
  font-weight: 400;
  font-family: var(--bxp-charlie-text-font-family);
  align-self: stretch;
  padding-top: ${wplToken('space.050')};
  max-height: 17.75rem;
  overflow-y: auto;
  & div:first-of-type {
    padding: ${wplToken('space.300')} ${wplToken('space.200')}
      ${wplToken('space.100')} ${wplToken('space.200')};
  }
`;

export const searchResultStyle = css`
  padding: ${wplToken('space.100')} ${wplToken('space.200')};
  cursor: pointer;
  &:hover {
    background: ${getColor('n20')};
  }
  &:focus {
    background: ${getColor('n20')};
  }
  &:active {
    background: ${getColor('n30')};
  }
`;

export const searchBackButton = css`
  display: none;
  ${getMediaDown('md')} {
    display: block;
    padding-top: ${wplToken('space.100')};
    padding-left: ${wplToken('space.100')};
  }
`;

export const searchNotFoundStyle = css`
  ${getMediaDown('md')} {
    padding-top: ${wplToken('space.1000')};
  }
  display: block;
  font-size: 1.125rem;
  font-weight: 400;
  font-family: var(--bxp-charlie-text-font-family);
  color: ${getColor('n80')};
  padding: ${wplToken('space.0')} ${wplToken('space.200')};
  padding-top: ${wplToken('space.300')};
  align-self: stretch;
  text-align: center;
`;
